export class NotFoundError extends Error {
    constructor(message) {
        super(message); // (1)

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
